/** The value as a person reads it: the unit follows directly for "°" and
 *  "%", after a space for any other ("26 cm"). */
function valueText(value: number, unit: string | undefined): string {
  const number = value.toLocaleString("en-US", { maximumFractionDigits: 1 });
  if (!unit) return number;
  return unit === "°" || unit === "%" ? number + unit : `${number} ${unit}`;
}

/**
 * A native range input with its label and its value always visible, so the
 * arrow, Home, End and Page keys work without code and a screen reader reads
 * both. `onChange` fires on every movement; `onCommit` when the user lets go,
 * for a caller that sends a request per change.
 */
export function Slider(props: {
  label: string;
  value: number;
  min: number;
  max: number;
  /** Default 1. */
  step?: number;
  /** "°", "cm" */
  unit?: string;
  onChange(v: number): void;
  onCommit?(v: number): void;
  disabled?: boolean;
}): JSX.Element {
  const { label, value, min, max, step = 1, unit, onChange, onCommit } = props;
  return (
    <label className="tb-slider">
      <span className="tb-slider-label">{label}</span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={props.disabled}
        onChange={(event) => onChange(Number(event.target.value))}
        onPointerUp={(event) =>
          onCommit?.(Number((event.target as HTMLInputElement).value))
        }
        onKeyUp={(event) =>
          onCommit?.(Number((event.target as HTMLInputElement).value))
        }
      />
      <output className="tb-slider-value">{valueText(value, unit)}</output>
    </label>
  );
}
